export function schema_conversion(prevColumnNames) {
	return {
		title: "Paramètres",
		type: "object",
		// "description": "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean id nisl at sapien bibendum aliquam. Suspendisse potenti. Vivamus tempor quis lacus ac sagittis. Aenean at mi ut leo pharetra malesuada. Praesent pretium posuere nisi, ac vehicula diam commodo in. Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos. Aenean et tempus purus. Aenean feugiat eros nisl, ut efficitur nulla gravida vel. Interdum et malesuada fames ac ante ipsum primis in faucibus. Morbi eget elit sed mauris commodo interdum congue ut est. Proin eu commodo mauris. Maecenas et dignissim augue. Phasellus eu convallis purus. Morbi a augue pulvinar, luctus libero sit amet, dictum sapien. Praesent pellentesque metus at tortor eleifend tristique.",
		properties: {
			column: {
				title: "Colonne d'origine",
				type: "string",
				options: {
					inputAttributes: {
						class: "form-control dropdown-colonne",
					},
				},
			},
			column_to: {
				title: "Colonne de conversion",
				type: "string",
				options: {
					inputAttributes: {
						class: "form-control dropdown-colonne",
					},
				},
			},
			list_convert: {
				type: "string",
				title: "Liste de conversion",
			},
			convert_fron: {
				type: "string",
				title: "Unité de départ",
			},
			convert_to: {
				type: "string",
				title: "Unité de conversion",
			},
			precision: {
				default: 2,
				type: "integer",
				title: "Nombre maximum de chiffres après la virgule",
			},
		},
	};
}
